import { UIElement, UIElementOptions } from '../common/ui/uiElement';
import { UIManager } from '../common/ui/uiManager';
import { Game } from './game';

export interface TimePanelOptions extends UIElementOptions {
  callback: Function;
}

export class TimePanel extends UIElement {
  protected remainingTime: number;
  protected duration: number;
  protected started: boolean;
  protected callback: Function;

  constructor(options: TimePanelOptions) {
    super(options);
    this.started = false;
    this.duration = 0;
    this.remainingTime = 0;
    this.callback = options.callback;
  }

  public setDuration(seconds:number) {
    this.duration = (seconds * 1000);
    this.remainingTime = this.duration;
  }

  public start() {
    this.remainingTime = this.duration;
    this.started = true;
  }

  public stop() {
    this.started = false;
  }

  public reset() {
    this.remainingTime = this.duration;
    this.started = false;
  }

  public extendRemainingTime(amount: number) {
    this.remainingTime += amount;
  }

  public pause() {
    this.started = false;
  }

  public resume() {
    this.started = true;
  }

  public update() {
    super.update();

    if(this.started) {
      this.remainingTime -= this.deltaTime;
      if(this.remainingTime < 0)
        this.remainingTime = 0;
    }
  }

  public draw() {
    // UIManager.ctx.fillStyle = '#00aa0088';
    // UIManager.ctx.fillRect(this.getScreenX(), this.getScreenY(), this.width, this.height);

    let percent = this.duration > 0 ? (this.remainingTime / this.duration) : 1;
    if(percent > 1)
      percent = 1;

    let startAngle = 0 - (Math.PI / 2);
    let endAngle = startAngle - ((2 * Math.PI) * percent);
    let radius = (this.width/2) - 2;

    UIManager.ctx.save();

    UIManager.ctx.translate(this.getScreenX() + (this.width/2), this.getScreenY() + (this.height/2));

    UIManager.ctx.lineWidth = 5;

    UIManager.ctx.beginPath();
    UIManager.ctx.arc(0, 0, radius, 0, 2 * Math.PI);
    UIManager.ctx.strokeStyle = '#00000040';
    UIManager.ctx.stroke();

    UIManager.ctx.beginPath();
    UIManager.ctx.arc(0, 0, radius, startAngle, endAngle, true);
    UIManager.ctx.strokeStyle = '#0000FF';
    UIManager.ctx.stroke();

    if(this.duration > 0) {
      UIManager.ctx.font = '18px arial';
      UIManager.ctx.fillStyle = '#ffffff';
      UIManager.ctx.textAlign = 'center';
      UIManager.ctx.textBaseline = 'middle';
      let rem = Math.floor((this.remainingTime+999) / 1000);
      UIManager.ctx.fillText(rem.toString(), 0, UIManager.isMobile ? 0 : 2);
    }

    UIManager.ctx.restore();

    if(percent == 0 && this.started) {
      this.pause();
      this.callback();
    }
  }
}